import React, { useState, useEffect, useContext } from 'react';
import { ThemeContext } from '../context/ThemeContext'; // Fixed import path

function OperatorDashboard() {
  const [tasks, setTasks] = useState([]);
  const [stats, setStats] = useState({
    total: 0,
    pending: 0,
    inProgress: 0,
    completed: 0
  });
  const { currentTheme } = useContext(ThemeContext);

  useEffect(() => {
    fetchTasks();
    fetchStats();
  }, []);

  const fetchTasks = async () => {
    try {
      const operatorId = sessionStorage.getItem('userId');
      const response = await fetch('https://alphaproduction.co/tasks.php', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          operation: 'get_recent_tasks',
          operator_id: operatorId
        })
      });
      const data = await response.json();
      setTasks(data);
    } catch (error) {
      console.error('Error fetching tasks:', error);
    }
  };

  const fetchStats = async () => {
    try {
      const operatorId = sessionStorage.getItem('userId');
      const response = await fetch('https://alphaproduction.co/tasks.php', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          operation: 'get_stats',
          operator_id: operatorId
        })
      });
      const data = await response.json();
      setStats(data);
    } catch (error) {
      console.error('Error fetching stats:', error);
    }
  };

  const primaryColor = currentTheme?.primary || '#0d6efd';
  const secondaryColor = currentTheme?.secondary || '#6f42c1';

  return (
    <div className="container-fluid py-4">
      {/* Header */}
      <div className="row mb-4">
        <div className="col-12">
          <div className="d-flex justify-content-between align-items-center">
            <h1 className="h3 mb-0" style={{ color: primaryColor }}>
              Operator Dashboard
            </h1>
            <span className="badge" style={{ 
              background: `linear-gradient(135deg, ${primaryColor}, ${secondaryColor})`,
              color: 'white'
            }}>
              Welcome, {sessionStorage.getItem('userName')}
            </span>
          </div>
        </div>
      </div>

      {/* Stats Cards */}
      <div className="row mb-4">
        <div className="col-xl-3 col-md-6 mb-4">
          <div className="card border-0 shadow-sm h-100" style={{ 
            background: `linear-gradient(135deg, ${primaryColor}08, ${secondaryColor}08)`,
            border: `2px solid ${primaryColor}20`
          }}>
            <div className="card-body">
              <div className="row align-items-center">
                <div className="col mr-2">
                  <div className="text-xs font-weight-bold text-uppercase mb-1" style={{ color: primaryColor }}>
                    Total Tasks
                  </div>
                  <div className="h5 mb-0 font-weight-bold" style={{ color: secondaryColor }}>
                    {stats.total}
                  </div>
                </div>
                <div className="col-auto">
                  <i className="fas fa-tasks fa-2x" style={{ color: `${primaryColor}40` }}></i>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="col-xl-3 col-md-6 mb-4">
          <div className="card border-0 shadow-sm h-100" style={{ 
            background: `linear-gradient(135deg, ${primaryColor}08, ${secondaryColor}08)`,
            border: `2px solid #ffc10720`
          }}>
            <div className="card-body">
              <div className="row align-items-center">
                <div className="col mr-2">
                  <div className="text-xs font-weight-bold text-uppercase mb-1" style={{ color: '#ffc107' }}>
                    Pending
                  </div>
                  <div className="h5 mb-0 font-weight-bold" style={{ color: '#ffc107' }}>
                    {stats.pending}
                  </div>
                </div>
                <div className="col-auto">
                  <i className="fas fa-clock fa-2x" style={{ color: '#ffc10740' }}></i>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="col-xl-3 col-md-6 mb-4">
          <div className="card border-0 shadow-sm h-100" style={{ 
            background: `linear-gradient(135deg, ${primaryColor}08, ${secondaryColor}08)`,
            border: `2px solid #17a2b820`
          }}>
            <div className="card-body">
              <div className="row align-items-center">
                <div className="col mr-2">
                  <div className="text-xs font-weight-bold text-uppercase mb-1" style={{ color: '#17a2b8' }}>
                    In Progress
                  </div>
                  <div className="h5 mb-0 font-weight-bold" style={{ color: '#17a2b8' }}>
                    {stats.inProgress}
                  </div>
                </div>
                <div className="col-auto">
                  <i className="fas fa-spinner fa-2x" style={{ color: '#17a2b840' }}></i>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="col-xl-3 col-md-6 mb-4">
          <div className="card border-0 shadow-sm h-100" style={{ 
            background: `linear-gradient(135deg, ${primaryColor}08, ${secondaryColor}08)`,
            border: `2px solid #28a74520`
          }}>
            <div className="card-body">
              <div className="row align-items-center">
                <div className="col mr-2">
                  <div className="text-xs font-weight-bold text-uppercase mb-1" style={{ color: '#28a745' }}>
                    Completed
                  </div>
                  <div className="h5 mb-0 font-weight-bold" style={{ color: '#28a745' }}>
                    {stats.completed}
                  </div>
                </div>
                <div className="col-auto">
                  <i className="fas fa-check-circle fa-2x" style={{ color: '#28a74540' }}></i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Recent Tasks */}
      <div className="row">
        <div className="col-12">
          <div className="card border-0 shadow-sm" style={{ 
            background: `linear-gradient(135deg, ${primaryColor}05, ${secondaryColor}05)`,
            border: `2px solid ${primaryColor}20`
          }}>
            <div className="card-header" style={{ 
              background: `linear-gradient(135deg, ${primaryColor}, ${secondaryColor})`,
              color: 'white'
            }}>
              <h5 className="mb-0">
                <i className="fas fa-history me-2"></i>
                Recent Tasks
              </h5>
            </div>
            <div className="card-body">
              {tasks.length === 0 ? (
                <div className="text-center py-4">
                  <i className="fas fa-tasks fa-3x mb-3" style={{ color: `${primaryColor}30` }}></i>
                  <p style={{ color: primaryColor }}>No tasks found</p>
                </div>
              ) : (
                <div className="table-responsive">
                  <table className="table table-hover">
                    <thead>
                      <tr>
                        <th style={{ color: primaryColor }}>Video Name</th>
                        <th style={{ color: primaryColor }}>Client</th>
                        <th style={{ color: primaryColor }}>Shoot Date</th>
                        <th style={{ color: primaryColor }}>Status</th>
                        <th style={{ color: primaryColor }}>Created</th>
                      </tr>
                    </thead>
                    <tbody>
                      {tasks.map((task) => (
                        <tr key={task.id}>
                          <td>{task.video_name || 'N/A'}</td>
                          <td>{task.client_name}</td>
                          <td>{task.shoot_date}</td>
                          <td>
                            <span className={`badge ${
                              task.status === 'completed' ? 'bg-success' :
                              task.status === 'in_progress' ? 'bg-info' :
                              task.status === 'cancelled' ? 'bg-danger' : 'bg-warning'
                            }`}>
                              {task.status.replace('_', ' ')}
                            </span>
                          </td>
                          <td>{new Date(task.created_at).toLocaleDateString()}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default OperatorDashboard;